import React from 'react'

export default props => (
    <tr {...props} style={{ backgroundColor: props.backgroundColor }}>
		{props.children}
	</tr>
)
